<template>
  <div
    class="hit-card overflow-visible"
    :class="{
      shadow: displayShadow,
      'bg-panel': !hideBackground,
    }"
    :ref="(ref) => (rootDomEl = ref)"
    @click="onDivClick"
  >
    <!-- @slot Content of the card -->
    <slot />
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

/**
 * A simple card component
 */
export default defineComponent({
  name: 'HitCard',
  components: {},
  props: {
    /**
     * Enable shadow
     */
    displayShadow: {
      type: Boolean,
      default: false,
    },
    /**
     * Hide background
     */
    hideBackground: Boolean,
  },
  data() {
    return {
      rootDomEl: null,
    };
  },
  methods: {
    onDivClick($event: Event) {
      /**
       * When the card is clicked
       */
      //@ts-ignore
      this.$emit('click', $event);
      $event.stopImmediatePropagation();
    },
  },
});
</script>

<style scoped lang="scss">
.hit-card {
  /* Match HitPanel outer shell; panel overrides when used as .hit-panel-card */
  border-radius: var(--hit-panel-radius, 1.25rem);
}
</style>
